import { LoadingState } from "../../../root-store/api-result.state";
import { DevicesActions } from "../actions";
import { CHZWaveDeviceState } from "../clarehome.state";

export const chZWaveDeviceReducer = (
    state: CHZWaveDeviceState = { result: null, uuid: "", callState: LoadingState.init },
    action: DevicesActions.Actions = null
): CHZWaveDeviceState => {
    switch (action.type) {
        case DevicesActions.ActionTypes.ClearZWaveDevicesState: {
            return {
                result: null,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case DevicesActions.ActionTypes.GetZWaveDevices: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case DevicesActions.ActionTypes.GetZWaveDevicesSuccess: {
            return {
                ...state,
                result: action.result.result,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
            };
        }

        case DevicesActions.ActionTypes.GetZWaveDevicesFailure: {
            return {
                ...state,
                result: null,
                callState: LoadingState.loaded,
                error: action.error,
            };
        }

        default: {
            return state;
        }
    }
};
